import AnimationKeyframes from './_animation-keyframes.js'

export default {
  name: 'Animation',
  values: {
    animationDuration: undefined,
    animationTimingFunction: undefined,
    animationIterationCount: undefined,
    animationDelay: undefined,
    animationDirection: undefined,
    animationFillMode: undefined,
    keyframes: {
      configSet: AnimationKeyframes,
      configValues: {},
    },
  },
  meta: {
    extendable: false,
  },
}
